import TopStrip from "./components/TopStrip";
import SiteNav from "./components/SiteNav";
import Hero from "./components/Hero";
import Picks from "./components/Picks";
import Flash from "./components/Flash";
import Themes from "./components/Themes";
import Process from "./components/Process";
import Tasting from "./components/Tasting";
import Ranking from "./components/Ranking";
import FlavorGuide from "./components/FlavorGuide";
import Faq from "./components/Faq";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans">
      <TopStrip />
      <SiteNav />
      <main>
        <Hero />
        <Picks />
        <Flash />
        <Themes />
        <Process />
        <Tasting />
        <Ranking />
        <FlavorGuide />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}